import { Button } from "devextreme-react/button";
import moment from "moment";
import React, { Fragment, useEffect, useRef, useState } from "react";

import { TextBox, SelectBox } from "devextreme-react";
import styled from "styled-components";
import { WS_URL } from "../../../ConstVariable";
import OperatorHelpNotes from "../../../OrderDetails/OperatorHelpNotes";
import SlotSelectionControl from "./SlotSelectionControl";
// import {  useNavigate} from 'react-router-dom'
import { useHistory } from "react-router-dom";
import axiosInstance from "../../../Middleware/axiosInstance";
import { useDispatch } from "react-redux";
import { SetError } from "../../../redux-store/actions";

const AIUtterance = styled.div`{
    background: rgba(234, 235, 238, 0.9);
    padding: 10px;
    font-family: "Helvetica Neue", "Segoe UI", Helvetica, Verdana,
        sans-serif;
    font-size: 14px;
    max-width: 600px;
    margin-bottom: 5px;
    text-align: right;
    word-wrap: normal;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
}`
const UserUtterance = styled.div`{
    background: rgba(153, 213, 226, 0.9);
    padding: 10px;
    font-family: "Helvetica Neue", "Segoe UI", Helvetica, Verdana,
        sans-serif;
    font-size: 14px;
    margin-bottom: 5px;
    max-width: 600px;
    text-align: left;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
}`

const SINGLE_CENTER_IMAGING_CONVERSATION_STATES = [{ 'GreetingState': 'Greeting' }, { 'ServiceRequestState': 'Service request' }, { 'InformTimeState': 'Slot selection' }, { 'DemographicState': 'Demographics' }, { 'MiscellaneousState': 'Miscellaneous' }]

const MULTI_CENTER_IMAGING_CONVERSATION_STATES = [{ 'GreetingState': 'Greeting' }, { 'ServiceRequestState': 'Service request' }, { 'MultiCenterState': 'Center selection' }, { 'InformTimeState': 'Slot selection' }, { 'DemographicState': 'Demographics' }, { 'MiscellaneousState': 'Miscellaneous' }]

const SINGLE_CENTER_GP_CONVERSATION_STATES = []

const MULTI_CENTER_GP_CONVERSATION_STATES = []

const makeWorkdeskActive = () => {
    var element1 = document.getElementById("li_workdesk");
    element1.classList.add("active");

    var element2 = document.getElementById("li_callhistory");
    element2.classList.remove("active");
    var element3 = document.getElementById("li_trash");
    element3.classList.remove("active");
    var element4 = document.getElementById("li_stats");
    if (element4) {
        element4.classList.remove("active");
    }
    var element5 = document.getElementById("li_manualOrder");
    element5.classList.remove("active");


    var element6 = document.getElementById("li_directCall");
    element6.classList.remove("active");
}
const ExamAndSlots = ({
    conversation_id,
    contact_number,
    center_id,
    center_name,
    index,
    number_of_conversations,
    scan_description,
    is_new_conversation,
    previous_conversation_details
}) => {

    const [chat, setChat] = useState([]) // store chat content.
    const userUtteranceInputRef = useRef() // reference to input box where user will type the response for AI. Using ref to avoid storing the type value in a STATE variable.
    const history = useHistory()
    const informationState = useRef(null);
    const [showSlotSelectionControl, setShowSlotSelectionControl] = useState(false)
    const [disableSlotSelectionControl, setDisableSlotSelectionControl] = useState(false)
    const [disableStateSelectionControl, setDisableStateSelectionControl] = useState(false)
    const [showOperatorNotes, setShowOperatorNotes] = useState(false)
    const [conversationCompleted, setConversationCompleted] = useState(false)
    const [conversationStateMachinePath, setConversationStateMachinePath] = useState([]);
    const selectedStateMachinePathRef = useRef(null);
    const chatWindowDivElementRef = useRef()
    const skipServiceRequestQuestionFromBot = useRef(false);
    const chatBoxStatus = useRef({disabled:false, palceholderText:"Please enter user input..", sendButtonColor:"#398DD7"})
    const isMulticenterWorkflow = useRef(false)
    const [hangupStatus,setHangupStatus]=useState(false)
    const dispatch=useDispatch()
    const [centerIdForCalendar, setCenterIdForCalendar] = useState(center_id)

    useEffect(() => {
        connect_to_chatty();
        return () => {
            // production code
            socketRef.current.close();
            socketRef.current = null;
        }
    }, [])


    const token = localStorage.getItem("MyToken")
    const header = `Authorization=Bearer ${token}`;

    const slotSelectionControlVisble = useRef(false);
    const slotSelectionControlDisabled = useRef(false);
    const socketRef = useRef(null)
    const currentState = useRef(null);
    const connect_to_chatty = () => {

        let ws_url = `${WS_URL}/oi/chatty/init/${token}`
        socketRef.current = new WebSocket(ws_url)
        socketRef.current.onopen = () => {
            console.log("Socket connection is now OPEN!");
            let msg = { event: "CONNECTED", center_id: center_id, conversation_id: conversation_id, contact: contact_number }
            socketRef.current.send(JSON.stringify(msg))
            if (is_new_conversation === true) {
                let msg = { event: "NEW-CONVERSATION", center_id: center_id, conversation_id: conversation_id, contact: contact_number }
                socketRef.current.send(JSON.stringify(msg))
            }
            if (is_new_conversation === false) {
                console.log("previous_conversation_details:", previous_conversation_details)
                if (previous_conversation_details) {
                    let _chat_details = []
                    previous_conversation_details.map(each => {
                        _chat_details.push({ utterance_from: each.utterance_from === "BOT" ? "AI" : each.utterance_from, msg: each.utterance, time: moment(each.creation_date).format("h:mm:ss a") })
                    })
                    setChat(_chat_details);
                }

                let msg = { event: "RELOAD-CONVERSATION", center_id: center_id, conversation_id: conversation_id, contact: contact_number }
                // console.log("Abhishek:", JSON.stringify(msg));
                socketRef.current.send(JSON.stringify(msg))


            }
        }
        socketRef.current.onclose = () => {
            console.log("Socket connection is now CLOSED!");
        }
        socketRef.current.onerror = () => {
            console.log("Socket connection is now ERRORD!");

        }
        socketRef.current.onmessage = (in_msg) => {
            let json_message = JSON.parse(in_msg.data)
            let curretHangupStatus=true;
            setHangupStatus(prev=>{curretHangupStatus=prev; return prev})
            if(json_message.event_type=="CALL_DISCONNECTED" && curretHangupStatus==false){
                dispatch(SetError({
                    severity: "warning",
                    message:`The current conversation is no longer valid. Please click on the restart button. ( conv# ${json_message.conversation_id} )` ,
                }))
                setChat((prevState) => [...prevState, { utterance_from: "AI", msg: `The current conversation has been disconnected. (conv# ${json_message.conversation_id})`, time: moment().format("h:mm:ss a") }])
                setConversationCompleted(true);
                setDisableSlotSelectionControl(true);
                return 
            }else if(json_message.event_type=="CALL_DISCONNECTED"){
                return 
            }
            let response = json_message.response.replace(/<.*?>/gi, "");
            // console.log("current_state", json_message.information_state.current_state)
            // console.log("response_code", json_message.information_state.response_code)
            chatBoxStatus.current.palceholderText = "Please enter user input.."
            chatBoxStatus.current.sendButtonColor = "#398DD7"
            chatBoxStatus.current.disabled = false
            
            if (currentState.current !== json_message.information_state.current_state) {
                currentState.current = json_message.information_state.current_state;
                axiosInstance().get(`/oi/chatty/state-machine-path/${conversation_id}`).then(result => {
                    // console.log(result)
                    setConversationStateMachinePath(result.data.response)

                }).catch(error => {
                    console.error(error)
                })
            }

            // Slot selection
            if (slotSelectionControlVisble.current === false && json_message.information_state.current_state === "InformTimeState" && json_message.information_state?.first_available_slot_date != null && json_message.information_state?.conversationWorkflowType === "IMAGING_APPT") {
                setShowSlotSelectionControl(true);
                setShowOperatorNotes(true);
                slotSelectionControlVisble.current = true;
            }

            // multi-center dialog
            if (slotSelectionControlVisble.current === false && json_message.information_state.current_state === "MultiCenterState" && json_message.information_state?.current_internal_state === "CONFIRM_IF_CALLER_HAS_CENTRE_PREFERRENCE" && json_message.information_state?.conversationWorkflowType === "IMAGING_APPT") {
                setShowSlotSelectionControl(true);
                setShowOperatorNotes(true);
                slotSelectionControlVisble.current = true;
            }

            // multi-center dialog
            if (json_message.information_state.current_state === "MultiCenterState" && json_message.information_state?.current_internal_state === "CONFIRM_USER_PREFERRED_CENTER" && json_message.information_state?.conversationWorkflowType === "IMAGING_APPT") {

            }

            if (json_message.information_state.current_state === "ServiceRequestState" && json_message.information_state?.dummy_center_id) {
                // alert(json_message.information_state.center_id)
                let _center_id_for_calendar = json_message.information_state.center_id;
                if (json_message.information_state?.dummy_center_id) {
                    _center_id_for_calendar = json_message.information_state?.dummy_center_id;
                }
                if (_center_id_for_calendar !== centerIdForCalendar) {
                    // console.log("_center_id_for_calendar:",_center_id_for_calendar)
                    setCenterIdForCalendar(_center_id_for_calendar)
                }
            }

            if (slotSelectionControlVisble.current === false && json_message.information_state.current_state === "InformTimeState" && json_message.information_state?.conversationWorkflowType === "GP_APPT") {
                setShowSlotSelectionControl(true);
                slotSelectionControlVisble.current = true;
            }

            if (slotSelectionControlDisabled.current === false && json_message.information_state.current_state === "DemographicState") {
                slotSelectionControlDisabled.current = true;
                setDisableSlotSelectionControl(true);

            }
            informationState.current = json_message.information_state;
            if (json_message.information_state.last_response === "HANGUP_CALL" || json_message.information_state.last_response === "FORWARD_CALL") {
                setConversationCompleted(true);
                setHangupStatus(true)
                return
            }


            if (skipServiceRequestQuestionFromBot.current === false && json_message.information_state.response_code.includes("img_service_request.sr.bodypart_and_modality_1") && number_of_conversations === 1) {
                setTimeout(() => {
                    userUtteranceInputRef.current.instance.option("value", scan_description)
                    sendUserUtterance();
                }, 1000);
                // sendAutoMessage("yes",1000);
            }

            if (json_message.information_state.response_code.includes("img_inform_time.it.request_for_confirmation_double") || 
                json_message.information_state.response_code.includes("img_inform_time.it.request_for_confirmation_default_response_single") || 
                json_message.information_state.response_code.includes("img_inform_time.it.request_for_confirmation_default_response_double") || 
                json_message.information_state.response_code.includes("img_inform_time_v2.ask_for_time") 
                ) {
                    if (isMulticenterWorkflow.current == false) {
                        response = `Please select a slot from the calendar.`
                        chatBoxStatus.current.disabled = true
                        chatBoxStatus.current.palceholderText = "Please Confirm Selected Slot in Summary"
                        chatBoxStatus.current.sendButtonColor = "grey"    
                    } else {
                        response = ""
                        chatBoxStatus.current.disabled = false
                        chatBoxStatus.current.palceholderText = "Please enter user input.."
                        chatBoxStatus.current.sendButtonColor = "#398DD7"    
                    }
                }

            if (json_message.information_state.response_code.includes("img_multi_center.ml.service_available_at_all_centers_ask_caller_if_interested_in_a_particlar_center") || 
            json_message.information_state.response_code.includes("img_multi_center.ml.service_available_at_some_centers_ask_caller_if_interested_in_a_particlar_center")
                ) {
                    response = `Please select a slot from the calendar.`
                    chatBoxStatus.current.disabled = true
                    chatBoxStatus.current.palceholderText = "Please Confirm Selected Slot in Summary"
                    chatBoxStatus.current.sendButtonColor = "grey"
                    isMulticenterWorkflow.current = true
                }

            if (json_message.information_state.response_code.includes("img_service_request.sr.confirm_bodypart_and_modality") || 
                json_message.information_state.response_code.includes("img_service_request.sr.confirm_bodypart_and_modality_new")) {
                response = <div style={{ display: "inline" }}>You have requested for <span style={{ color: 'black', fontWeight: "bold" }}>{json_message.information_state?.imaging_service_request_details?.toUpperCase()}</span> . Is that correct?</div>
            }
            if (json_message.information_state.response_code.includes("img_service_request.sr.fasting_duration_and_guideline")) {
                chatBoxStatus.current.disabled = false
                chatBoxStatus.current.palceholderText = "Please enter user input.."
                chatBoxStatus.current.sendButtonColor = "#398DD7"
            }

            if (json_message.information_state.response_code.includes("img_service_request.sr.additional_cost_exact") || 
            json_message.information_state.response_code.includes("img_service_request.sr.additional_cost_approx") || 
            json_message.information_state.response_code.includes("img_service_request.sr.additional_cost_with_gap") || 
            json_message.information_state.response_code.includes("img_service_request.sr.additional_cost_dummy")
            ) {
                chatBoxStatus.current.disabled = false
                chatBoxStatus.current.palceholderText = "Please enter user input.."
                chatBoxStatus.current.sendButtonColor = "#398DD7"
            }
    
            if (json_message.information_state.response_code.includes("img_service_request.sr.additional_question_first_attempt") || 
            json_message.information_state.response_code.includes("img_service_request.sr.first_safety_question")  
            ) {
                chatBoxStatus.current.palceholderText = "Please enter user input.."
                chatBoxStatus.current.sendButtonColor = "#398DD7"
                chatBoxStatus.current.disabled = false
            }

            if (json_message.information_state.response_code.includes("img_demographics.dm.first_name") || 
            json_message.information_state.response_code.includes("img_demographics.dm.check_if_appointment_for_existing_patient")  
            ) {
                chatBoxStatus.current.palceholderText = "Please enter user input.."
                chatBoxStatus.current.sendButtonColor = "#398DD7"
                chatBoxStatus.current.disabled = false
            }

            if (json_message.information_state.response_code.includes("img_demographics.dm.email_id")) {
                chatBoxStatus.current.palceholderText = "Please enter user input.."
                chatBoxStatus.current.sendButtonColor = "#398DD7"
                chatBoxStatus.current.disabled = false
            }

            // greeting message.
            if (json_message.information_state.response_code.includes("img_greeting.greeting_message")) {
                sendAutoMessage("yes", 1000);
            }
            if (json_message.information_state.current_internal_state === "SCAN_DETAILS_CONFIRMATION") {
                sendAutoMessage("yes", 1000);
                chatBoxStatus.current.palceholderText = "Please enter user input.."
                chatBoxStatus.current.sendButtonColor = "#398DD7"
                chatBoxStatus.current.disabled = false
            }

            if (json_message.information_state.response_code.includes("img_demographics.dm.confirm_dob") || json_message.information_state.response_code.includes("img_inform_time.it.confirm_patient_gender")) {
                sendAutoMessage("yes", 1000);
            }

            setChat((prevState) => [...prevState, { utterance_from: "AI", msg: response, time: moment().format("h:mm:ss a") }])

            if (json_message.information_state.current_state === "InformTimeState" && json_message.information_state?.conversationWorkflowType === "IMAGING_APPT" && slotConfirmed.current === true && selectedSlot.current == null) {
                sendAutoMessage("yes", 1000)
                slotConfirmed.current = false;
            }

            if (json_message.information_state.current_state === "InformTimeState" && json_message.information_state?.conversationWorkflowType === "IMAGING_APPT" && slotConfirmed.current === true && selectedSlot.current != null) {
                userUtteranceInputRef.current.instance.option("value", moment(selectedSlot.current.schedule).format("D MMMM [at] h:mm a"));
                sendUserUtterance();
                selectedSlot.current = null
            }


            // scroll
            if (chatWindowDivElementRef.current) {
                chatWindowDivElementRef.current.scrollTop = chatWindowDivElementRef.current.scrollHeight;
            }

        }
    }

    const sendAutoMessage = (msg, delay_in_milliseconds) => {
        setTimeout(() => {
            userUtteranceInputRef.current.instance.option("value", msg)
            sendUserUtterance();
        }, delay_in_milliseconds);
    }

    const moveConversationStateMachine = () => {
        // alert(selectedStateMachinePathRef.current.instance.option("value"));
        let target_state = selectedStateMachinePathRef.current.instance.option("value");
        let msg = JSON.stringify({
            event: "RESET_STATE_MACHINE",
            conversation_id: conversation_id,
            target_state: target_state
        })
        if (target_state === "ServiceRequestState" || target_state === "GreetingState" || target_state === "InformTimeState") {
            slotSelectionControlDisabled.current = false;
            slotSelectionControlVisble.current = false;

            setShowSlotSelectionControl(false);
            setShowOperatorNotes(false);
            setDisableSlotSelectionControl(false);
            skipServiceRequestQuestionFromBot.current = true;
            slotConfirmed.current=false;
            selectedSlot.current=null;

        }
        // console.log(msg)
        selectedStateMachinePathRef.current.instance.option("value", null)
        socketRef.current.send(msg)
    }

    const showConversation = () => {
        console.log("chat:", chat)
        return chat.map((item,index) => {
            if (item.utterance_from === "AI") {
                if (item.msg === "CONVERSATION_TERMINATED_BY_CALLER" || item.msg === "CONVERSATION_TERMINATED_BY_AI") {
                    return <AIUtterance key={Math.random()} style={{ background: "pink" }}><b>AI</b>: {item.msg}<div style={{ fontSize: "x-small", fontStyle: "italic", width: "100%", textAlign: "right" }}>{item.time}</div></AIUtterance>;
                } else {
                    return <AIUtterance key={Math.random()} style={{backgroundColor:chat.length-1==index?"#f3f5ba":"",color:chat.length-1==index?"black":""}}><b>AI</b>: {item.msg}<div style={{ fontSize: "x-small", fontStyle: "italic", width: "100%", textAlign: "right" }}>{item.time}</div></AIUtterance>;

                }
            }
            if (item.utterance_from === "USER") {
                return <UserUtterance key={Math.random()}><b>User</b>: {item.msg}<div style={{ fontSize: "x-small", fontStyle: "italic", width: "100%", textAlign: "right" }}>{item.time}</div></UserUtterance>;
            }
        });
    };

    const sendUserUtterance = () => {
        // console.log(userUtteranceInputRef.current.instance.option("value"));
        if (userUtteranceInputRef.current.instance.option("value")) {
            setChat((prevState) => [...prevState, { utterance_from: "USER", msg: userUtteranceInputRef.current.instance.option("value"), time: moment().format("h:mm:ss a") }])
            socketRef.current.send(JSON.stringify({ event: "DATA", conversation_id: conversation_id, "data": userUtteranceInputRef.current.instance.option("value") }))
            userUtteranceInputRef.current.instance.option("value", "")

            if (chatWindowDivElementRef.current) {
                chatWindowDivElementRef.current.scrollTop = chatWindowDivElementRef.current.scrollHeight;
            }
        }
    }
    const slotConfirmed = useRef(false)
    // Selected date time handler
    const orgSelectedCenterId = useRef(center_id);
    const selectedCenterId = useRef(center_id);
    const selectedCenterName = useRef(center_name);
    const selectedSlot = useRef(null);
    const ImagingSelectedSlotHandler = (selected_center_id, selected_center_name, selected_time_slot, confirm) => {
        slotConfirmed.current = confirm;
        selectedSlot.current = selected_time_slot;

        if ((informationState.current.current_state === "MultiCenterState" && informationState.current.current_internal_state === "CONFIRM_IF_CALLER_HAS_CENTRE_PREFERRENCE" && informationState.current.conversationWorkflowType === "IMAGING_APPT") && selected_center_id != selectedCenterId.current) {
            selectedCenterId.current = selected_center_id
            selectedCenterName.current = selected_center_name
            userUtteranceInputRef.current.instance.option("value", selected_center_name);
            sendUserUtterance();

        }
        else {
            userUtteranceInputRef.current.instance.option("value", moment(selectedSlot.current.schedule).format("D MMMM [at] h:mm a"));
            sendUserUtterance();
        }
    }

    const GPSelectedSlotHandler = (selectedSlot, confirm) => {
        if (selectedSlot === null) {
            return;
        }
        userUtteranceInputRef.current.instance.option("value", moment(selectedSlot.schedule).format("D MMMM [at] h:mm a"));
        if (confirm === true) {
            sendUserUtterance();
            slotConfirmed.current = true;
        }
    }



    const selectedCenterHandler = (center_id, center_name) => {
        selectedCenterId.current = center_id;
        selectedCenterName.current = center_name;
    }

    const component_height = (100 / number_of_conversations) + "%";
    return (
        <Fragment>
            <div style={{ display: "flex", flexDirection: "column", 
            // borderColor: "blue", 
            // borderStyle: "solid", 
            padding: "5px", 
            borderWidth: "3px", height: `${component_height}` }}>

                <div style={{ display: "flex", justifyContent: "space-between", backgroundColor: "skyblue" }}>
                    <div style={{ margin: "auto", textAlign: "left", fontSize: "16px" }}>Appointment #{index + 1} </div>
                    {/* <div style={{ display: "flex", justifyContent: "flex-end" }}> <Button hint="Stop this conversation" icon="close" onClick={() => { closeConversation(conversation_id); }}></Button><Button hint="Minimize" icon="collapse"></Button> </div> */}

                </div>
                <div style={{ display: "flex", justifyContent: "end", gap: "10px" }}>
                    <SelectBox 
                        label="Conversation path" 
                        dataSource={conversationStateMachinePath} 
                        valueExpr={"name"} 
                        displayExpr={"name"} 
                        ref={selectedStateMachinePathRef} 
                        disabled={conversationCompleted?conversationCompleted:disableStateSelectionControl}
                    />
                    <Button 
                        text="Go" 
                        icon="arrowright" 
                        rtlEnabled={true} 
                        onClick={() => { moveConversationStateMachine() }} 
                        disabled={conversationCompleted?conversationCompleted:disableStateSelectionControl}
                    />
                </div>
                <div style={{ display: "flex", flexGrow: "1", width: "100%", padding: "5px", height:`${component_height}`, overflow:"hidden"}}>
                    {/* chat containter */}
                    <div style={{ width: "100%", display: "flex", flexDirection: "column" }}>
                        {/* chat */}
                        <div ></div>
                        <div style={{ overflowY: "scroll", minHeight: "0px",  flex: "1 1 0", borderColor: "lightgrey", borderStyle: "solid", borderWidth: "1px" }} ref={chatWindowDivElementRef}>{chat && showConversation()}
                        </div>
                        {/* chat input */}
                        <div style={{ padding: "3px", borderColor: "lightgrey", borderStyle: "solid", borderWidth: "1px" }}>
                            {!conversationCompleted && <div style={{ display: "flex", justifyContent: "flex-end", alignSelf: "end" }}>
                                <TextBox 
                                    ref={userUtteranceInputRef} 
                                    placeholder={chatBoxStatus.current.palceholderText} 
                                    style={{ width: "100%", marginRight: "5px" }} 
                                    onEnterKey={() => { 
                                        sendUserUtterance() }
                                    }
                                    disabled={chatBoxStatus.current.disabled}
                                />
                                {" "}<Button 
                                    onClick={() => { 
                                        sendUserUtterance() }
                                    } 
                                    text="Send" 
                                    icon="arrowright" 
                                    type="default" 
                                    rtlEnabled={true}
                                    disabled={chatBoxStatus.current.disabled}
                                    style={{marginLeft:"5px", backgroundColor:chatBoxStatus.current.sendButtonColor}} 
                                />
                            </div>}
                            {
                                conversationCompleted && <div style={{ display: "flex", justifyContent: "center" }}>
                                    <Button 
                                        width="auto" 
                                        onClick={() => {
                                            // sendUserUtterance() 
                                            document.getElementById("menu-bar").style.display = "block";
                                            makeWorkdeskActive();
                                            history.push(`/redirect?callerId=${contact_number}`)                                            
                                        }} 
                                        text="Complete at workdesk" 
                                        icon="arrowleft" 
                                        type="success" 
                                        rtlEnabled={false} 
                                    />
                                </div>}
                        </div>
                    </div>
                    {/* Imaging appointment show calendar & operator notes. */}
                    {
                        informationState.current?.conversationWorkflowType === "IMAGING_APPT" &&
                        <><div style={{ width: "100%", borderColor: "lightgrey", borderStyle: "solid", borderWidth: "1px" }}>
                            {" "}
                            {showSlotSelectionControl && 
                            <SlotSelectionControl
                                slotSelectionHandler={(selectedCenterId, selectedCenterName, selectedTimeSlot, is_confirmed) => ImagingSelectedSlotHandler(selectedCenterId, selectedCenterName, selectedTimeSlot, is_confirmed)}
                                disableSlotSelectionControl={disableSlotSelectionControl}
                                conversationID={conversation_id}
                                conversationWorkflowType={informationState.current?.conversationWorkflowType}
                                center_id={centerIdForCalendar}
                                dataFromApiRequestedCallback={(dataFromApiRequested) => {setDisableStateSelectionControl(dataFromApiRequested)}}
                            />}
                            {" "}
                        </div>
                            <div style={{ width: "100%", }}>
                                {" "}
                                <div style={{ height: "30%", borderColor: "lightgrey", borderStyle: "solid", borderWidth: "1px" }}>
                                    {showOperatorNotes &&
                                        <OperatorHelpNotes
                                            selectDateTime={null}
                                            center_id={informationState.current?.center_id}
                                            modality={informationState.current?.modality === undefined ? "" : informationState.current?.modality}
                                            bodypart={informationState.current?.bodypart === undefined ? "" : informationState.current?.bodypart}
                                            bodypart_group={informationState.current?.bodypart_group === undefined ? "" : informationState.current?.bodypart_group}
                                            protocol={informationState.current?.protocol === undefined ? "" : informationState.current?.protocol}
                                            purpose_of_study={informationState.current?.purpose_of_study === undefined ? "" : informationState.current?.purpose_of_study}
                                            laterality={informationState.current?.laterality === undefined ? "" : informationState.current?.laterality}
                                            modalityGeneric={informationState.current?.modality_generic === undefined ? "" : informationState.current?.modality_generic}
                                            bodypartGeneric={informationState.current?.bodypart_generic === undefined ? "" : informationState.current?.bodypart_generic}
                                            protocolGeneric={informationState.current?.protocol_generic === undefined ? "" : informationState.current?.protocol_generic}
                                            purposeOfStudyGeneric={informationState.current?.purpose_of_study_generic === undefined ? "" : informationState.current?.purpose_of_study_generic}
                                            lateralityGeneric={informationState.current?.laterality_generic === undefined ? "" : informationState.current?.laterality_generic}
                                            bodypartGroupGeneric={informationState.current?.bodypart_group_generic === undefined ? "" : informationState.current?.bodypart_group_generic}
                                            speciality={informationState.current?.speciality === undefined ? "" : informationState.current?.speciality}
                                            order_description={""}
                                            pregnancyWeeks={informationState.current?.weeks_since_pregnant === undefined ? "" : informationState.current?.weeks_since_pregnant}
                                            conversationID={informationState.current?.conversation_id}
                                            operatorNotesShouldFetch={true}
                                            operatorNotesFetchHandler={null}
                                        />
                                    }
                                </div>

                                {/* {showOperatorNotes && <div style={{ padding: "5px", height: "70%", borderColor: "lightgrey", borderStyle: "solid", borderWidth: "1px",overflowY: "scroll",
                                        minHeight: "0px"}}>
                                    <div style={{padding: "5px", width: "100%",  fontSize:"15px", fontWeight:"bold", background:"lightgray" }}>NER Details</div>
                                    <div style={{background:"skyblue", paddingLeft:"2px"}}>
                                    <div style={{padding: "2px", display: "flex" }}>
                                        <div style={{ width: "30%" }}><b>Scan description</b>:</div>
                                        <div>{informationState.current?.user_service_request_utterance}</div>
                                    </div>
                                    <div style={{padding: "2px", display: "flex" }}>
                                        <div style={{ width: "30%" }}><b>Modality</b>:</div>
                                        <div>{informationState.current?.modality === null ? "" : informationState.current?.modality.toUpperCase()}</div>
                                    </div>
                                    
                                    {informationState.current?.bodypart && <div style={{ padding: "2px",display: "flex" }}>
                                        <div style={{ width: "30%" }}><b>Bodypart</b>:</div>
                                        <div>{informationState.current?.bodypart === null ? "" : informationState.current?.bodypart.toUpperCase()} ({informationState.current?.bodypart_generic === null ? "" : informationState.current?.bodypart_generic.toUpperCase()})</div>
                                    </div>}
                                    {informationState.current?.bodypart_group && <div style={{ padding: "2px",display: "flex" }}>
                                        <div style={{ width: "30%" }}><b>Bodypart Group</b>:</div>
                                        <div>{informationState.current?.bodypart_group === null ? "N/A" : informationState.current?.bodypart_group.toUpperCase()} ({informationState.current?.bodypart_group_generic === null ? "" : informationState.current?.bodypart_group_generic.toUpperCase()})</div>
                                    </div>}
                                    {informationState.current?.protocol &&  <div style={{ padding: "2px",display: "flex" }}>
                                        <div style={{ width: "30%" }}><b>Protocol</b>:</div>
                                        <div>{informationState.current?.protocol === null ? "" : informationState.current?.protocol.toUpperCase()} ({informationState.current?.protocol_generic === null ? "" : informationState.current?.protocol_generic.toUpperCase()})</div>
                                    </div>}
                                    {informationState.current?.purpose_of_study && <div style={{ padding: "2px",display: "flex" }}>
                                        <div style={{ width: "30%" }}><b>Purpose of study</b>:</div>
                                        <div>{informationState.current?.purpose_of_study === null ? "" : informationState.current?.purpose_of_study.toUpperCase()} ({informationState.current?.purpose_of_study_generic === null ? "" : informationState.current?.purpose_of_study_generic.toUpperCase()})</div>
                                    </div>}
                                    {informationState.current?.laterality && <div style={{ padding: "2px",display: "flex" }}>
                                        <div style={{ width: "30%" }}><b>Laterality</b>:</div>
                                        <div>{informationState.current?.laterality === null ? "" : informationState.current?.laterality.toUpperCase()} ({informationState.current?.laterality_generic === null ? "" : informationState.current?.laterality_generic.toUpperCase()})</div>
                                    </div>}
                                    {informationState.current?.speciality && <div style={{ padding: "2px",display: "flex" }}>
                                        <div style={{ width: "30%" }}><b>Speciality</b>:</div>
                                        <div>{informationState.current?.speciality === null ? "" : informationState.current?.speciality.toUpperCase()}</div>
                                    </div>}
                                    </div>
                                    <div style={{height:"3px"}}>{" "}</div>
                                    <div style={{padding: "5px", width: "100%",  fontSize:"15px", fontWeight:"bold",background:"lightgray" }}>Patient Details</div>
                                    <div style={{background:"lightgoldenrodyellow", paddingLeft:"2px"}}>
                                    {informationState.current?.first_name_original_text && <div style={{ padding: "2px",display: "flex" }}>
                                        <div style={{ width: "30%" }}><b>First Name</b>:</div>
                                        <div>{informationState.current?.first_name_original_text?.toUpperCase()}</div>
                                    </div>}
                                    {informationState.current?.last_name_original_text && <div style={{ padding: "2px",display: "flex" }}>
                                        <div style={{ width: "30%" }}><b>Last Name</b>:</div>
                                        <div>{informationState.current?.last_name_original_text?.toUpperCase()}</div>
                                    </div>}
                                    {informationState.current?.date_of_birth && <div style={{ padding: "2px",display: "flex" }}>
                                        <div style={{ width: "30%" }}><b>DOB</b>:</div>
                                        <div>{moment(informationState.current?.date_of_birth).format("DD-MMM-YYYY")}</div>
                                    </div>}
                                    </div>
                                    
                                </div>} */}
                                {" "}
                            </div>
                        </>
                    }
                    {/* GP Appointment show calendar. */}
                    {
                        informationState.current?.conversationWorkflowType === "GP_APPT" &&
                        <><div style={{ width: "100%", borderColor: "lightgrey", borderStyle: "solid", borderWidth: "1px" }}>
                            {" "}
                            {showSlotSelectionControl && <SlotSelectionControl
                                slotSelectionHandler={(selectedTimeSlot, is_confirmed) => GPSelectedSlotHandler(selectedTimeSlot, is_confirmed)}
                                disableSlotSelectionControl={disableSlotSelectionControl}
                                conversationID={conversation_id}
                                conversationWorkflowType={informationState.current?.conversationWorkflowType}
                                center_id={center_id}
                            />}
                            {" "}</div></>
                    }
                </div>
            </div>
        </Fragment>
    );
};

export default ExamAndSlots;
